import { gql } from '@apollo/client';
import { Card } from '@apollo/orbit';
import React from 'react';

import { PermissionBlockCard } from 'src/components/permissionGuards/permissionBlockCard/PermissionBlockCard';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import {
  LaunchDetails,
  LaunchHistorySchemaDiffFragment,
} from './launchDetails/LaunchDetails';
import { LaunchHistoryList } from './launchHistoryList/LaunchHistoryList';
import { LaunchHistoryListItemFragment } from './launchHistoryList/launchHistoryListItem/LaunchHistoryListItem';

const LaunchHistoryLaunchFragment = gql`
  fragment LaunchHistoryLaunchFragment on Launch {
    id
    ...LaunchHistoryListItemFragment
  }
  ${LaunchHistoryListItemFragment}
`;

export const LaunchHistoryGraphVariantFragment = gql`
  fragment LaunchHistoryGraphVariantFragment on GraphVariant {
    id
    activeSchemaPublish {
      id
    }
    launchHistory {
      id
      ...LaunchHistoryLaunchFragment
      ...LaunchHistorySchemaDiffFragment
    }
  }
  ${LaunchHistoryLaunchFragment}
  ${LaunchHistorySchemaDiffFragment}
`;

export const LaunchHistory = ({
  variant,
  selectedLaunchId,
  isCloudSupergraph,
}: {
  variant: GraphQLTypes.LaunchHistoryGraphVariantFragment;
  selectedLaunchId: string;
  isCloudSupergraph: Boolean;
}) => {
  return (
    <Card className="flex flex-col overflow-hidden rounded-b-none">
      <div className="flex overflow-hidden">
        {variant.launchHistory ? (
          <>
            <div className="flex-2 shrink-0 overflow-auto pb-8">
              <LaunchHistoryList
                launches={variant.launchHistory}
                selectedLaunchId={selectedLaunchId}
                activeSchemaPublishId={variant.activeSchemaPublish?.id}
                isCloudSupergraph={isCloudSupergraph}
              />
            </div>
            <div className="flex-3 shrink-0 overflow-auto border-l border-primary">
              <LaunchDetails
                launchId={selectedLaunchId}
                launchHistory={variant.launchHistory}
                isCloudSupergraph={isCloudSupergraph}
              />
            </div>
          </>
        ) : (
          <PermissionBlockCard />
        )}
      </div>
    </Card>
  );
};
